// Material Dashboard 2 React components
import MDBox from "components/MDBox";
// Material Dashboard 2 React example components
import SimpleBackdrop from "components/MDLoader_Backdrop";
import MDTypography from "components/MDTypography";
// Dashboard components
import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import {
  getImage,
  getBrandLandingData,
  getRestaurantData,
  getRestaurantPageData,
  getSingleCampaignAPI,
} from "./_request";

import CateringReward from "../../assets/images/icons/catering-rewards/cr-logo-black.png";
import FoodImg from "../../assets/images/icons/catering-rewards/food-img.svg";

import "./styles.css";
import { useAuth } from "context";
import formatNumberWithCommas from "../../core/uitls/formatNumberWithCommas.ts";
import { RESTAURANT_LEVEL_HEX_COLOR, ORDER_SIZE } from "../../core/constant";

import AuthModal from "./components/AuthModal/index.js";

import CustomNavbar from "components/custom/Navbar";
import LoyaltyTiers from "components/custom/LoyaltyTiers";
import HowItWorks from "components/custom/HowItWorks";
import AboutSection from "components/custom/AboutUs";
import FinePrint from "components/custom/FinePrint";
import Footer from "components/custom/Footer";
import Banner from "components/custom/Bannner";
import NotFound from "components/custom/NotFound";
import { Alert, Snackbar } from "@mui/material";

import TagManager from "react-gtm-module";
import config from "config/config";

function Restaurant() {
  const params = useParams();
  const location = useLocation();
  const isBrandPage = location.pathname.startsWith("/brand");
  const [loader, setLoader] = useState(true);
  const [campaignLoader, setCampaignLoader] = useState(false);
  const [restaurantData, setRestaurantData] = useState(undefined);
  const [brandInfo, setBrandInfo] = useState(null);
  const { darkMode, logout } = useAuth();
  const [restaurantPageDetails, setRestaurantPageDetails] = useState();
  const [logoIdUrl, setLogoIdUrl] = useState("");
  const [bannerImgUrl, setBannerImgUrl] = useState("");
  const [restaurantImgUrl, setRestaurantImgUrl] = useState("");
  const [popularCustomerImg1Url, setPopularCustomerImg1Url] = useState("");
  const [popularCustomerImg2Url, setPopularCustomerImg2Url] = useState("");
  const [popularCustomerImg3Url, setPopularCustomerImg3Url] = useState("");
  const [popularCustomerImg4Url, setPopularCustomerImg4Url] = useState("");
  const [popularCustomerImg5Url, setPopularCustomerImg5Url] = useState("");
  const [logoStatus, setLogoStatus] = useState(2);
  const [bannerImgStatus, setBannerImgStatus] = useState(2);
  const [gtmCode, setGtmCode] = useState("");
  const [campaignDetails, setCampaignDetails] = useState(undefined);
  // Auth modal states
  const [authSection, setAuthSection] = useState("code");
  const [open, setOpen] = useState(false);
  const [gtmInitialized, setGtmInitialized] = useState(false);
  const campaignCode = new URL(window.location.href).searchParams.get("code") || null;
  const referrerCode = new URL(window.location.href).searchParams.get("referrer") || null;

  const [campaignChecked, setCampaignChecked] = useState(false);
  const [notFound, setNotFound] = useState(false);

  const getCampaignDetails = async (ownershipParams = {}) => {
    try {
      setCampaignLoader(true);
      const {
        data: { success, data },
      } = await getSingleCampaignAPI(campaignCode, ownershipParams);
      if (success && data?.campaign) {
        setCampaignDetails(data.campaign);
      } else {
        setCampaignChecked(true);
        setCampaignDetails(null);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setCampaignLoader(false);
    }
  };

  useEffect(() => {
    if (!campaignCode && !referrerCode) return;
    if (isBrandPage) {
      getCampaignDetails({ scope: "BRAND", scopeEntityId: params.id });
    } else if (restaurantData) {
      getCampaignDetails({ scope: "STORE", scopeEntityId: restaurantData.restaurantStore.id });
    }
  }, [restaurantData]);

  const initializePageImages = (page) => {
    const isGtmEnabled = config[process.env?.REACT_APP_ENV?.toUpperCase()]?.GTM_ENABLED;
    const pageGtmCode = page?.gtmCode;
    setGtmCode(pageGtmCode);
    if (isGtmEnabled && pageGtmCode && !gtmInitialized) {
      TagManager.initialize({ gtmId: pageGtmCode });
      setGtmInitialized(true);
    }

    getLogoUrl(page?._logo);
    getBannerImgUrl(page?._bannerImg);
    getRestaurantImgUrl(page?._restaurantImg);
    getPopularCustomerImg1Url(page?._popularCustomerImg1);
    getPopularCustomerImg2Url(page?._popularCustomerImg2);
    getPopularCustomerImg3Url(page?._popularCustomerImg3);
    getPopularCustomerImg4Url(page?._popularCustomerImg4);
    getPopularCustomerImg5Url(page?._popularCustomerImg5);
  };

  useEffect(() => {
    if (isBrandPage) {
      // Brand page: single API call returns brand + landingPage + loyaltyPlan
      const fetchBrandData = async () => {
        try {
          const {
            data: { success, data },
          } = await getBrandLandingData(params.id);
          if (success) {
            setBrandInfo({
              id: data.brand?.id,
              name: data.brand?.name,
              loyaltyPlan: data.loyaltyPlan,
              entityAddress: data.brand?.entityAddress,
              city: data.brand?.city,
              state: data.brand?.state,
              zipCode: data.brand?.zipCode,
              country: data.brand?.country,
            });
            setRestaurantPageDetails(data.landingPage);
            if (data.landingPage) {
              initializePageImages(data.landingPage);
            }
          } else {
            setNotFound(true);
          }
        } catch (err) {
          console.log(err);
          setNotFound(true);
        } finally {
          setLoader(false);
        }
      };
      fetchBrandData();
    } else {
      // Store page: existing two API calls
      const fetchStoreData = async () => {
        try {
          const {
            data: { success, data },
          } = await getRestaurantData(params.id);
          if (success) {
            setRestaurantData(data);
          } else {
            setNotFound(true);
          }
        } catch (e) {
          console.log(e);
          setNotFound(true);
        } finally {
          setLoader(false);
        }
      };
      const fetchPageDetails = async () => {
        try {
          const response = await getRestaurantPageData(params?.id);
          const restaurantPageObj = response?.data?.data?.restaurantPageObj;
          if (response?.data?.success && restaurantPageObj) {
            setRestaurantPageDetails(restaurantPageObj);
            initializePageImages(restaurantPageObj);
          }
        } catch (err) {
          console.log(err);
        }
      };
      fetchStoreData();
      fetchPageDetails();
    }
  }, []);

  const getAddress = () => {
    if (!landingData?.address) return undefined;
    let addressString = landingData.address;
    if (landingData.addressLine2) {
      addressString += `, ${landingData.addressLine2}`;
    }
    if (landingData.city) {
      addressString += `, ${landingData.city}`;
    }
    if (landingData.state) {
      addressString += `, ${landingData.state}`;
    }
    if (landingData.country) {
      addressString += `, ${landingData.country}`;
    }
    if (landingData.zipCode) {
      addressString += `, ${landingData.zipCode}`;
    }
    return addressString;
  };

  const getLogoUrl = async (_logo) => {
    if (_logo) {
      setLogoStatus(2);
      const {
        data: { data, success },
      } = await getImage(_logo);
      if (success) {
        setLogoStatus(1);
        setLogoIdUrl(data);
      } else {
        setLogoStatus(0);
      }
    } else {
      setLogoStatus(0);
    }
  };

  const getBannerImgUrl = async (_bannerImg) => {
    if (_bannerImg) {
      setBannerImgStatus(2);
      const {
        data: { data, success },
      } = await getImage(_bannerImg);
      if (success) {
        setBannerImgStatus(1);
        setBannerImgUrl(data);
      } else {
        setBannerImgStatus(0);
      }
    } else {
      setBannerImgStatus(0);
    }
  };

  const getRestaurantImgUrl = async (_restaurantImg) => {
    if (_restaurantImg) {
      const {
        data: { data, success },
      } = await getImage(_restaurantImg);
      if (success) {
        setRestaurantImgUrl(data);
      }
    }
  };

  const getPopularCustomerImg1Url = async (_popularCustomerImg1) => {
    if (_popularCustomerImg1) {
      const {
        data: { data, success },
      } = await getImage(_popularCustomerImg1);
      if (success) {
        setPopularCustomerImg1Url(data);
      }
    }
  };

  const getPopularCustomerImg2Url = async (_popularCustomerImg2) => {
    if (_popularCustomerImg2) {
      const {
        data: { data, success },
      } = await getImage(_popularCustomerImg2);
      if (success) {
        setPopularCustomerImg2Url(data);
      }
    }
  };

  const getPopularCustomerImg3Url = async (_popularCustomerImg3) => {
    if (_popularCustomerImg3) {
      const {
        data: { data, success },
      } = await getImage(_popularCustomerImg3);
      if (success) {
        setPopularCustomerImg3Url(data);
      }
    }
  };

  const getPopularCustomerImg4Url = async (_popularCustomerImg4) => {
    if (_popularCustomerImg4) {
      const {
        data: { data, success },
      } = await getImage(_popularCustomerImg4);
      if (success) {
        setPopularCustomerImg4Url(data);
      }
    }
  };

  const getPopularCustomerImg5Url = async (_popularCustomerImg5) => {
    if (_popularCustomerImg5) {
      const {
        data: { data, success },
      } = await getImage(_popularCustomerImg5);
      if (success) {
        setPopularCustomerImg5Url(data);
      }
    }
  };

  // Derived display data — flattened shape for UI components
  const landingData = restaurantData
    ? {
        name: restaurantData.restaurantStore?.name,
        storeId: restaurantData.restaurantStore?.id,
        loyaltyPlan: restaurantData.loyaltyPlan,
        email: restaurantData.restaurantStore?.email,
        phoneCountryCode: restaurantData.restaurantStore?.phoneCountryCode,
        phoneNumber: restaurantData.restaurantStore?.phoneNumber,
        restaurantPrefix: restaurantData.restaurantStore?.restaurantPrefix,
        gohighlevelSyncEnabled: restaurantData.restaurantStore?.gohighlevelSyncEnabled,
        address: restaurantData.restaurantStore?.storeAddressLine1,
        addressLine2: restaurantData.restaurantStore?.storeAddressLine2,
        city: restaurantData.restaurantStore?.city,
        state: restaurantData.restaurantStore?.state,
        zipCode: restaurantData.restaurantStore?.zipCode,
        country: restaurantData.restaurantStore?.country,
      }
    : brandInfo
    ? {
        name: brandInfo.name,
        brandId: brandInfo.id,
        loyaltyPlan: brandInfo.loyaltyPlan,
        address: brandInfo.entityAddress,
        city: brandInfo.city,
        state: brandInfo.state,
        zipCode: brandInfo.zipCode,
        country: brandInfo.country,
      }
    : undefined;

  if (loader) {
    return <SimpleBackdrop />;
  }

  if (notFound) {
    return <NotFound />;
  }

  return (
    <>
      {/* DO NOT CHANGE!  */}
      {/* GTM CODE INSTALLATION  */}
      {config[process.env?.REACT_APP_ENV?.toUpperCase()]?.GTM_ENABLED &&
        restaurantPageDetails?.gtmCode && (
          <div
            dangerouslySetInnerHTML={{
              __html: `<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${restaurantPageDetails.gtmCode}"
                height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`,
            }}
          />
        )}

      {/* Snackbar for campaign status */}
      <Snackbar
        open={campaignChecked}
        onClose={(_, reason) => {
          if (reason === "clickaway") {
            setCampaignChecked(false);
          }
        }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={() => setCampaignChecked(false)} severity="warning" sx={{ width: "100%" }}>
          You’ll still earn cashback. Limited-time offer is no longer available.
        </Alert>
      </Snackbar>

      {/* MAIN UI  */}
      <div className="mainBackgroundColor">
        <CustomNavbar
          logoStatus={logoStatus}
          logoIdUrl={logoIdUrl}
          CateringReward={CateringReward}
          setAuthSection={setAuthSection}
          setOpen={setOpen}
        />

        <Banner
          bannerImgStatus={bannerImgStatus}
          bannerImgUrl={bannerImgUrl}
          FoodImg={FoodImg}
          landingData={landingData}
          setOpen={setOpen}
          setAuthSection={setAuthSection}
          campaignDetails={campaignDetails}
          campaignCode={campaignCode}
          gtmCode={gtmCode}
          referrerCode={referrerCode}
        />

        {/* <CateringMenu /> */}
        <AboutSection
          landingData={landingData}
          restaurantPageDetails={restaurantPageDetails}
          restaurantImgUrl={restaurantImgUrl}
        />

        {landingData?.loyaltyPlan?.plans?.length > 1 && !campaignDetails?.override && (
          <LoyaltyTiers
            landingData={landingData}
            campaignDetails={campaignDetails}
            formatNumberWithCommas={formatNumberWithCommas}
            ORDER_SIZE={ORDER_SIZE}
            RESTAURANT_LEVEL_HEX_COLOR={RESTAURANT_LEVEL_HEX_COLOR}
          />
        )}

        <HowItWorks />

        <MDBox
          mt={2}
          py={4}
          sx={{
            "@media (max-width:767px)": {
              mt: 1,
            },
          }}
        >
          {(popularCustomerImg1Url ||
            popularCustomerImg2Url ||
            popularCustomerImg3Url ||
            popularCustomerImg4Url ||
            popularCustomerImg5Url) && (
            <MDTypography
              fontSize="24px"
              fontWeight="medium"
              display="flex"
              justifyContent="center"
              sx={{
                "@media (max-width:767px)": {
                  fontSize: "16px",
                },
              }}
            >
              Some of our customers include
            </MDTypography>
          )}
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            gap={10}
            sx={{
              "@media (max-width:767px)": {
                flexWrap: "wrap",
                mt: 2,
                gap: 2,
              },
            }}
          >
            {popularCustomerImg1Url && (
              <img
                src={popularCustomerImg1Url}
                width={150}
                alt="_popularCustomerImg1"
                className="popuparCustomerMobile"
              />
            )}
            {popularCustomerImg2Url && (
              <img
                src={popularCustomerImg2Url}
                width={150}
                alt="_popularCustomerImg2"
                className="popuparCustomerMobile"
              />
            )}
            {popularCustomerImg3Url && (
              <img
                src={popularCustomerImg3Url}
                width={150}
                alt="_popularCustomerImg3"
                className="popuparCustomerMobile"
              />
            )}
            {popularCustomerImg4Url && (
              <img
                src={popularCustomerImg4Url}
                width={150}
                alt="_popularCustomerImg4"
                className="popuparCustomerMobile"
              />
            )}
            {popularCustomerImg5Url && (
              <img
                src={popularCustomerImg5Url}
                width={150}
                alt="_popularCustomerImg5"
                className="popuparCustomerMobile"
              />
            )}
          </MDBox>
        </MDBox>

        <FinePrint darkMode={darkMode} isBrandPage={isBrandPage} landingData={landingData} />

        <Footer
          CateringReward={CateringReward}
          restaurantPageDetails={restaurantPageDetails}
          landingData={landingData}
          getAddress={getAddress}
        />

        {campaignLoader && <SimpleBackdrop />}
      </div>
      <AuthModal
        authSection={authSection}
        open={open}
        setOpen={setOpen}
        campaignCode={campaignCode}
        referrerCode={referrerCode}
        campaignDetails={campaignDetails}
        storeId={landingData?.storeId}
        brandId={landingData?.brandId}
        logoStatus={logoStatus}
        logoIdUrl={logoIdUrl}
        CateringReward={CateringReward}
        gtmCode={gtmCode}
      />
    </>
  );
}

export default Restaurant;
